import React from "react";
import ReactDOM from "react-dom";
import {} from "@chakra-ui/react";
import "./index.css";
import App from "./App";
import AuthProvider from "./contexts/AuthProvider";

ReactDOM.render(
  <AuthProvider>
    <App />
  </AuthProvider>,
  document.getElementById("root")
);
